import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.1_@upstash+redis@1.34.8_@vercel+kv@3_5d303cdb7ec49b6bb362de46c4e786ef/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}